import { render } from "./referenda.vue?vue&type=template&id=f5da8656&scoped=true"
import script from "./referenda.vue?vue&type=script&lang=js"
export * from "./referenda.vue?vue&type=script&lang=js"

import "./referenda.vue?vue&type=style&index=0&id=f5da8656&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5da8656"]])

export default __exports__